import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=126e4d22"
import script from "./Wechat.vue?vue&type=script&lang=js"
export * from "./Wechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports